<template>
  <div class="user">
    <div style="font-size: 24px; font-weight: bold;">微信代理</div>
    <a-divider></a-divider>
    <a-descriptions style="padding-left: 8px;" :column="1">
      <template #title>
        <span>代理信息</span><span style="color: grey; font-size: 12px;">( 仅统计近 24 小时 )</span>
      </template>
      <a-descriptions-item label="推送次数"><pre style="margin: initial; line-height: 26px;">{{ proxyCount }}</pre></a-descriptions-item>
    </a-descriptions>
    <a-table
      :style="`font-size: ${isMobile() ? '10px': '14px'};`"
      :columns="columns"
      size="middle"
      :data-source="logs"
      :pagination="{ pageSize: 50 }"
      :scroll="{ x: 184, y: 640 }"
    >
      <template #title>
        <span style="font-size: 16px; font-weight: bold;">近期推送记录</span><span style="color: grey; font-size: 12px; font-weight: bold;">( 仅显示近 2 小时推送记录 )</span>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'time'">
          <pre style="margin: initial">{{ $moment(record.time * 1000).format('YYYY-MM-DD HH:mm:ss') }}</pre>
        </template>
        <template v-if="column.dataIndex === 'ip'">
          <pre style="margin: initial">{{ record.ip }}</pre>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  data () {
    const columns = [
      {
        title: '记录 ID',
        dataIndex: 'id',
        width: 40
      }, {
        title: '时间',
        dataIndex: 'time',
        width: 72
      }, {
        title: '请求 IP',
        dataIndex: 'ip',
        width: 72
      }
    ];
    const logs = [];
    return {
      columns,
      proxyCount: 12138,
      loading: true,
      registCode: [],
      logs
    };
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted () {
    try {
      const r = await this.$api().user.getWechatProxyLog();
      this.logs = r.data.logs;
      this.proxyCount = r.data.total;
      this.loading = false;
    } catch (e) {
      this.$message().error(e.message);
    }
  }
};
</script>
<style scoped>
.user {
  height: 100%;
  width: 100%;
}
</style>
